import { $Q, $Qll } from "../utils/query-selector";
import { dataToggle } from "../utils/toggle-dataset";
import { validateForm } from "../services/sendFormB2B";
import axios from "axios";

const setScrollPosition = ($recover) => {
    let current = "#login";

    if ($recover.dataset.active === "true") {
        current = "#recover";
    }

    window.location.hash = current;
    setTimeout(() => window.scrollTo(0, 0), 100);

};

const toggleLoginForm = () => {
    const loginForm = $Q('.login-form');
    const recoveryForm = $Q('.recover-form');

    if (!loginForm || !recoveryForm) return;

    const recoveryToggle = $Qll('.login__toggle');

    if (!recoveryToggle.length) return;

    recoveryToggle.forEach((item) => {
        item.addEventListener('click', (event) => {
            event.preventDefault();
            dataToggle(recoveryForm);
            dataToggle(loginForm);
            setScrollPosition(recoveryForm);
        });
    });

    if (window.location.hash === "#recover") {
        dataToggle(recoveryForm);
        dataToggle(loginForm);
    }
}

const fetchCurrentRPPS = async (updateForm, updateFormVat) => {
    const customerId = window.customer?.id;
    const {data: { response: { body: { customer: { note } } } }, status} = await axios.get(`https://centrale-fillers-app.herokuapp.com/get_customer?id=${customerId}`);
    if(status == 400) return;

    if(!note) return;

    const lstSplit = note.split(";");
    const splitFinal = lstSplit.find(split => split.includes("code_medical:"))
        ?   lstSplit.find(split => split.includes("code_medical:")).split("code_medical:")[1]
        : "";
    const splitFinalVat = lstSplit.find(split => split.includes("VAT:"))
        ?   lstSplit.find(split => split.includes("VAT:")).split("VAT:")[1]
        : "";
    const input = $Q('#RegisterForm-NoteCodeMedical', updateForm);
    const inputVat = $Q('#RegisterForm-Vat', updateFormVat);
    if (!input || !inputVat) return;
    input.value = splitFinal;
    inputVat.value = splitFinalVat;
}

const FormUpdateCustomerVat = (updateFormVat) => {
    updateFormVat.addEventListener('submit', async (event) => {
        event.preventDefault();
        const form = new FormData(event.target);
        const formData = {
            "vat": form.get('vat'),
        }
        const response = await validateForm("/v1/Vat", formData);
        showMessageValidationVat(response.isValid);
        if (response && response.isValid === true) {
            const { data, status } = await axios.post('https://centrale-fillers-app.herokuapp.com/v1/accountVatValidate', {
                code: form.get('vat'),
                id: form.get('id'),
            });

            if(status == 201){
                alert(updateFormVat.dataset.messageOk);
                window.location.reload();
            } else {
                alert(updateFormVat.dataset.messageFailed);
            }
        }
    });
}

const initFormUpdateCustomer = async () => {
    const updateForm = $Q("#customer_updatecustomer");
    const updateFormVat = $Q("#customer_updatecustomer_vat");
    if (!updateForm || !updateFormVat) return;

    fetchCurrentRPPS(updateForm, updateFormVat);

    updateForm.addEventListener('submit', async (event) => {
        event.preventDefault();
        const form = new FormData(event.target);
        const { data, status } = await axios.post('https://centrale-fillers-app.herokuapp.com/update_customer', {
            code: form.get('code_medical'),
            id: form.get('id'),
        });

        if(status == 201){
            alert(updateForm.dataset.messageOk);
            window.location.reload();
        } else {
            alert(updateForm.dataset.messageFailed);
        }
    });

    FormUpdateCustomerVat(updateFormVat);
}

const showMessageValidationVat = (stateVat) => {
    const messageValidation = $Q('.message-validation-vat');

    if(!messageValidation) {
        return;
    }

    messageValidation.classList.remove('hidden');
    messageValidation.innerHTML = stateVat 
        ? messageValidation.dataset.messageSuccess
        : messageValidation.dataset.messageFailed;

    if(stateVat) {
        messageValidation.classList.contains('message-validation-vat--failed')
            ? messageValidation.classList.remove('message-validation-vat--failed')
            : null;
        messageValidation.classList.add('message-validation-vat--success');
    } else {
        messageValidation.classList.contains('message-validation-vat--success')
            ? messageValidation.classList.remove('message-validation-vat--success')
            : null;
        messageValidation.classList.add('message-validation-vat--failed');
    }
}

export { toggleLoginForm, initFormUpdateCustomer };
